import { get } from 'lodash/fp';
import { LOCALE } from 'helpers/i18n';
import favoritesUrlByLocales from './favoritesUrlByLocales.json';

export const FAVORITE_URL_KEY_BY_LOCALE = get([LOCALE], favoritesUrlByLocales);
